<template>
	<g>
		<defs>
		<path id="deposits-a" class="cls-1" d="M19.1574268,8.0066481l-5.9729843-3.0368938c-.7413568-.3776369-1.6267738-.3768849-2.3688831,0l-5.9729848,3.0368938c-.1741495.0887671-.2839799.2678061-.2839799.4633951v10.3233337c0,.2869892.2328262.5198154.5198154.5198154h13.8431826c.2869892,0,.5198154-.2328262.5198154-.5198154v-10.3233337c0-.1955891-.1098309-.3746281-.2839813-.4633951ZM11.2872286,5.8965445c.4460936-.2271843.9794493-.2271843,1.4255419,0l5.6890049,2.8924589v1.5075388H5.5982242v-1.5075388s5.6890054-2.8924594,5.6890044-2.8924589ZM14.3463144,15.9276228h-.6533422v-1.8264999c0-.2869892-.2328262-.5198154-.5198154-.5198154h-2.3463154c-.2869892,0-.5198154.2328262-.5198154.5198154v1.8264999h-.6533422c-.2869892,0-.5198154.2328253-.5198154.5198145v1.8261242h-1.2480078v-6.9373884h8.2282753v6.9373884h-1.2480078v-1.8261242c0-.2869892-.2328262-.5198154-.5198135-.5198145ZM12,15.9276228h-.6533422v-1.3066845h1.3066845v1.3066845h-.6533422ZM5.5982242,11.3361731h1.2480078v6.9373884h-1.2480078v-6.9373884ZM10.1735001,16.9672527h1.3066845v1.3063087h-1.3066845v-1.3063087ZM12.5198154,18.2735615v-1.3063087h1.3066845v1.3063087h-1.3066845ZM17.1537685,18.2735615v-6.9373884h1.2480068v6.9373884s-1.2480087,0-1.2480068,0Z"/>
		<path id="deposits-a" class="cls-1" d="M11.4212732,8.8946495h1.2038593c.299778,0,.5428534-.2430754.5428534-.5429001,0-.2998714-.2430754-.5429001-.5428534-.5429001h-1.2038593c-.2998247,0-.5429001.2430286-.5429001.5429001,0,.2998247.2430754.5429001.5429001.5429001Z"/>
		</defs>
		<g fill="none" fill-rule="evenodd">
		<rect
			width="24"
			height="24"
			fill="#E3E3E3"
			fill-opacity=".01"
			style="mix-blend-mode:color-burn"
		/>
		<use :fill="currentColor" :opacity="opacity" fill-rule="nonzero" xlink:href="#deposits-a" />
		</g>
	</g>
</template>

<script>
  export default {
    props: {
      currentColor: {
        type: String,
        default: 'black'
      },
      opacity: {
        type: String,
        default: '1'
      }
    }  
  }
</script>